import React, { ReactNode } from 'react';
import cn from 'classnames';

import UserDevice from 'services/user-device';

import './amount.scss';

interface Props {
    isDisabled?: boolean;
    isActive: boolean;
    onClick: DivEl['onClick'];
    children: ReactNode;
}

const Amount: React.FC<Props> = ({
    isActive,
    isDisabled,
    onClick,
    children,
}) => {
    const isDesktop = !UserDevice.getInstance()?.isDeviceMobile();

    return (
        <div
            onClick={isDisabled ? undefined : onClick}
            styleName={cn('stake', {
                'is-desktop': isDesktop,
                'is-active': isActive,
                'is-disabled': isDisabled,
            })}
        >
            {children}
        </div>
    );
};

export default Amount;
